"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isArray = Array.isArray;

/**
 * @param {Object} origin
 */
function pick(origin) {
  var result = {};

  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      var pickTo = void 0;

      if (isArray(key)) {
        pickTo = key[1] || key[0];
        key = key[0];
      } else {
        pickTo = key;
      }

      if (origin.hasOwnProperty(key)) {
        result[pickTo] = origin[key];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
}

exports.default = pick;